import { render, staticRenderFns } from "./taoc.vue?vue&type=template&id=5b4427dc&scoped=true&"
import script from "./taoc.vue?vue&type=script&lang=js&"
export * from "./taoc.vue?vue&type=script&lang=js&"
import style0 from "./taoc.vue?vue&type=style&index=0&id=5b4427dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4427dc",
  null
  
)

export default component.exports